import React from 'react';
import PropTypes from 'prop-types';

const PhoneNumber = ({phone}) => {
    if (!phone) {
        return null;
    }

    const number = `(${phone.number.substr(0, 3)}) ${phone.number.substr(3, 3)}-${phone.number.substr(6)}`;
    const ext = phone.ext ? ` x${phone.ext}` : '';

    return <span className='text-truncate'>{number + ext}</span>;
};

PhoneNumber.propTypes = {
    phone: PropTypes.shape({
        category: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired,
        ext: PropTypes.string
    }).isRequired
};

export default PhoneNumber;